import React from 'react';
import { Gift, Plus } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ValueStack() {
  const bonuses = [{
    title: 'Guía Anti-Abandono',
    desc: 'Qué hacer cuando no tenés ganas',
    value: '$3.000',
    img: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Calendario Runner 8 Semanas',
    desc: 'Para no fallar ni improvisar',
    value: '$4.000',
    img: 'https://images.unsplash.com/photo-1506784951206-b9627122efc7?auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Rutinas Express (10-15 min)',
    desc: 'Para días sin tiempo',
    value: '$3.500',
    img: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Planificador Semanal Runner',
    desc: 'Para sostener el hábito',
    value: '$2.500',
    img: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía de Ritmo y Respiración',
    desc: 'Para no agotarte rápido',
    value: '$3.000',
    img: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=200&q=80'
  }, {
    title: "Guía 'Qué hacer si te estancás'",
    desc: 'Para seguir avanzando sin frustrarte',
    value: '$3.000',
    img: 'https://images.unsplash.com/photo-1552674605-171d31fea3fa?auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="bg-light py-20 md:py-32" data-id="element-285">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <FadeIn data-id="element-287">
          <div className="text-center mb-12" data-id="element-288">
            <div className="inline-flex items-center justify-center p-3 bg-primary/10 text-primary rounded-full mb-6" data-id="element-289">
              <Gift className="w-8 h-8" data-id="element-290" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-4" data-id="element-291">
              Además, HOY te llevás{' '}
              <span className="text-primary" data-id="element-292">GRATIS:</span>
            </h2>
            <p className="text-xl text-gray-600" data-id="element-293">
              Todo este material complementario para asegurar tu éxito.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-294">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-295">
              <div className="bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col sm:flex-row items-center gap-6 relative overflow-hidden group hover:border-primary/30 transition-colors" data-id="element-296">
                <div className="w-full sm:w-32 h-32 flex-shrink-0 rounded-xl overflow-hidden" data-id="element-297">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-298" />
                </div>

                <div className="flex-grow text-center sm:text-left" data-id="element-299">
                  <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-bold rounded-full mb-2 uppercase tracking-wide" data-id="element-300">
                    Bono #{index + 1}
                  </div>
                  <h3 className="text-xl font-bold text-dark mb-1" data-id="element-301">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-302">{bonus.desc}</p>
                </div>

                <div className="flex-shrink-0 bg-gray-50 px-6 py-4 rounded-xl border border-gray-100 text-center w-full sm:w-auto" data-id="element-303">
                  <p className="text-sm text-gray-500 font-medium mb-1" data-id="element-304">
                    Valor normal
                  </p>
                  <p className="text-lg font-bold text-dark line-through decoration-red-500/50 decoration-2" data-id="element-305">
                    {bonus.value}
                  </p>
                  <p className="text-success font-bold text-sm mt-1" data-id="element-306">
                    HOY GRATIS
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-307">
          <div className="bg-dark text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-308">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-primary via-yellow-500 to-primary" data-id="element-309"></div>

            <h3 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-310">
              Resumen de tu inversión:
            </h3>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 mb-8" data-id="element-311">
              <div className="text-center" data-id="element-312">
                <p className="text-gray-400 text-lg mb-2" data-id="element-313">Valor total real:</p>
                <p className="text-4xl font-black text-gray-500 line-through decoration-red-500 decoration-4" data-id="element-314">
                  $30.000
                </p>
              </div>

              <div className="hidden md:flex bg-white/10 p-3 rounded-full" data-id="element-315">
                <Plus className="w-6 h-6 text-white" data-id="element-316" />
              </div>

              <div className="text-center" data-id="element-317">
                <p className="text-primary font-bold text-lg mb-2 uppercase tracking-widest" data-id="element-318">
                  Precio Hoy:
                </p>
                <p className="text-5xl md:text-6xl font-black text-white" data-id="element-319">
                  $13.999
                </p>
              </div>
            </div>

            <p className="text-gray-300 text-lg" data-id="element-320">
              Un único pago. Acceso de por vida a todo el material.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}